import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import PortalContractDetails from '../../shared/PortalContractDetails';
import Stepper from '../../shared/Stepper';
import PortalErrors from '../Portal/PortalErrors';
import { Route } from 'react-router-dom';
import ActivityIndicator from '../../shared/ActivityIndicator';
import {
  generateRoutes,
  getSteps,
  getOptionals,
  getRoutes,
  goBack
} from '../../../helpers/stepperFunctions';

class DigitalSale extends Component {
  state = {
    persisted: false,
    routeList: []
  };

  async componentDidMount() {
    let process = this.props.process;
    if (this.props.location.pathname.includes('validate-identity')) {
      process = 'digitalSaleWithUUP';
      await this.props.clearFinancing();
      await this.props.resetStepper();
      this.tryGetProcessAndSetRoutes(process);
    } else {
      this.props.persistFinancing();
      this.props.persistStepper();
    }
    this.props.globalParameters.validateSaleInvoices === null &&
      (await this.props.fetchGlobalParameters());
  }

  componentDidUpdate = () => {
    if (
      !this.state.persisted &&
      !this.props.location.pathname.includes('validate-identity')
    ) {
      this.tryGetProcessAndSetRoutes(this.props.process);
    }
  };

  tryGetProcessAndSetRoutes = process => {
    if (process) {
      const routeList = generateRoutes(process, this.props.globalParameters);
      this.props.setSteps(getSteps(routeList), getRoutes(routeList), process);
      this.props.setOptionalSteps(getOptionals(routeList));
      this.setState({ routeList, persisted: true });
    }
  };

  showContractDetails = () => {
    return (
      location.pathname !== '/digital-sale/validate-identity' &&
      location.pathname !== '/digital-sale/register-identity' &&
      location.pathname !== '/digital-sale/list-contracts'
    );
  };

  _renderStep = () => {
    const { location, saleCompleted, routes, skips, history } = this.props;
    const currentStep = routes.indexOf(location.pathname);

    const maxStep = this.props[`${this.props.process}Next`];
    const route = this.state.routeList.find(
      route => route.path === location.pathname
    );

    if (currentStep >= 0 && maxStep >= 0 && route) {
      if (
        currentStep <= maxStep ||
        (saleCompleted && location.pathname === '/digital-sale/end-sale')
      ) {
        return (
          <Fragment>
            {this.showContractDetails() && <PortalContractDetails />}
            <Stepper />
            <Route
              exact
              path={route.path}
              render={props => (
                <route.component
                  {...props}
                  goBack={() => goBack(routes, skips, location.pathname)}
                />
              )}
            />
          </Fragment>
        );
      } else {
        history.push(routes[maxStep]);
        this.props.newAlert(
          'error',
          'ERROR:',
          'No puedes ingresar a este paso sin haber completado los anteriores.'
        );
      }
    } else {
      history.push(routes[maxStep]);
      this.props.newAlert(
        'error',
        'ERROR:',
        'La ruta ingresada no existe en el registro de venta.'
      );
    }
    return null;
  };

  render() {
    const {
      location,
      server_errors,
      baseErrorOpen,
      baseErrorText,
      baseErrorTitle,
      baseErrorRoute,
      toggleBaseErrorModal,
      loadingParameters
    } = this.props;
    if (loadingParameters && location.pathname.includes('validate-identity'))
      return <ActivityIndicator />;
    if (!this.state.persisted) return null;
    return (
      <Fragment>
        <PortalErrors
          server_errors={server_errors}
          baseErrorOpen={baseErrorOpen}
          baseErrorText={baseErrorText}
          baseErrorTitle={baseErrorTitle}
          toggleModal={toggleBaseErrorModal}
          baseErrorRoute={baseErrorRoute}
        />
        {this._renderStep()}
      </Fragment>
    );
  }
}

DigitalSale.propTypes = {
  resetStepper: PropTypes.func.isRequired,
  setSteps: PropTypes.func.isRequired,
  setOptionalSteps: PropTypes.func.isRequired,
  persistFinancing: PropTypes.func.isRequired,
  persistStepper: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired
};

export default DigitalSale;
